import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TabI } from '../../models/navigation-tabI';


@Component({
    selector: 'app-tab-navigator',
    templateUrl: './tab-navigator.component.html',
    styleUrls: ['./tab-navigator.component.scss'],
})
export class TabNavigatorComponent {

    @Input() public tabs: TabI[] | undefined;

    @Output() public selectedTabDetails: EventEmitter<any> = new EventEmitter();


    /**
     * Sets the selected Tab
     * @param {TabI} selectedTabDetails
     * @returns {void}
     */
    public selectedTab(selectedTabDetails: TabI): void {
        this.selectedTabDetails.emit(selectedTabDetails);
    }
}
